import React from 'react';
import styled from 'styled-components';
import { Grid, LayoutList } from 'lucide-react';

export type FileViewMode = 'grid' | 'list';

export function ViewModeToggle({ value, onChange }: { value: FileViewMode; onChange: (view: FileViewMode) => void }) {
  return <Group role="group" aria-label="문서 보기 방식">
    <Toggle type="button" $active={value === 'grid'} onClick={() => onChange('grid')}
      title="갤러리" aria-label="갤러리" aria-pressed={value === 'grid'}><Grid size={14} /></Toggle>
    <Toggle type="button" $active={value === 'list'} onClick={() => onChange('list')}
      title="리스트" aria-label="리스트" aria-pressed={value === 'list'}><LayoutList size={14} /></Toggle>
  </Group>;
}
const Group = styled.div`
  display: inline-flex; flex-shrink: 0;
  border-radius: ${({ theme }) => theme.sizes.borderRadiusSm};
  border: 0.5px solid ${({ theme }) => theme.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'};
  overflow: hidden;
`;
const Toggle = styled.button<{ $active: boolean }>`
  width: 32px; height: 32px; display: inline-flex; align-items: center; justify-content: center; border: none;
  background: ${({ $active, theme }) => $active ? theme.colors.bgHover : 'transparent'};
  color: ${({ $active, theme }) => $active ? theme.colors.textPrimary : theme.colors.textSecondary}; cursor: pointer;
  &:hover { background: ${({ theme }) => theme.colors.bgHover}; color: ${({ theme }) => theme.colors.textPrimary}; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.colors.brand}; outline-offset: -2px; }
`;
